import React, { FC } from "react";

import { SmartDropdown, SmartDropdownProps } from "@xapp/components";

export const INTEGRATIONS: { id: string; name: string }[] = [
    { id: "none", name: "I don't use an FSM" },
    { id: "boberdoo", name: "boberdoo" },
    { id: "leadperfection", name: "LeadPerfection" },
    { id: "jobber", name: "Jobber" },
    {id: "contractor-appointments", name: "Contractor Appointments" },
    { id: "servicetitan", name: "ServiceTitan" },
    { id: "housecallpro", name: "Housecall Pro" },
    { id: "fieldpulse", name: "FieldPulse" },
    { id: "fieldroutes", name: "FieldRoutes" },
    { id: "sfl", name: "Surefire Local" },
    { id: "lacrm", name: "LACRM" },
    { id: "zapier", name: "Zapier" },
    { id: "other", name: "Other" },
];

export interface IntegrationDropdownProps extends Omit<SmartDropdownProps, "options"> {
    /**
     * Only show one of the integrations
     */
    limitIntegrations?: string[];
    /**
     * It will purposely omit the integrations if provided
     */
    omitIntegrations?: string[];
}

export const IntegrationDropdown: FC<IntegrationDropdownProps> = (props) => {
    const { limitIntegrations, omitIntegrations, ...rest } = props;

    const copy = [...INTEGRATIONS];

    if (limitIntegrations) {
        const limit = limitIntegrations.map((integration) => integration.toLowerCase());
        copy.filter((integration) => limit.includes(integration.id));
    }
    if (omitIntegrations) {
        const omit = omitIntegrations.map((integration) => integration.toLowerCase());
        copy.filter((integration) => !omit.includes(integration.id));
    }

    return <SmartDropdown {...rest} slugLabel="Select an FSM" inputLabel="Search for an FSM" options={copy} />;
};
